// Upsells du tiroir panier : pack de 3, passage à l'abonnement, changement de fréquence.
(function () {
  function items() { return document.querySelector('cart-drawer-items'); }

  // Change une ligne (quantité et/ou plan d'abonnement) puis redessine le tiroir et la pastille panier.
  function changeLine(line, quantity, plan) {
    var ci = items();
    if (!ci) return;
    ci.enableLoading(line);
    var body = { line: Number(line), quantity: Number(quantity), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
    if (plan !== undefined) body.selling_plan = plan === '' ? null : Number(plan);
    fetch(routes.cart_change_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(body) }))
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.errors) { var e = document.getElementById('CartDrawer-CartErrors'); if (e) e.textContent = state.errors; return; }
        var parse = function (html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); };
        var inner = document.querySelector('#CartDrawer .drawer__inner');
        var fresh = parse(state.sections['cart-drawer'], '.drawer__inner');
        if (inner && fresh) inner.innerHTML = fresh.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble');
        var freshBubble = parse(state.sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sl-cart-drawer', cartData: state });
      })
      .catch(function () { var e = document.getElementById('CartDrawer-CartErrors'); if (e && window.cartStrings) e.textContent = window.cartStrings.error; })
      .finally(function () { var c = items(); if (c) c.disableLoading(line); });
  }

  document.addEventListener('click', function (e) {
    var pack = e.target.closest('[data-sl-pack-line]');
    if (pack) { e.preventDefault(); changeLine(pack.getAttribute('data-sl-pack-line'), 3); return; }
    var sub = e.target.closest('[data-sl-sub-line]');
    if (sub) { e.preventDefault(); changeLine(sub.getAttribute('data-sl-sub-line'), sub.getAttribute('data-qty') || 1, sub.getAttribute('data-plan')); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sl-plan-line]');
    if (sel) { e.stopPropagation(); changeLine(sel.getAttribute('data-sl-plan-line'), sel.getAttribute('data-qty') || 1, sel.value); }
  }, true);
})();
